import React, { useState, useEffect } from "react";
 
export const ImageCarousel = ({ images, title }) => {
  const [current, setCurrent] = useState(0);
 
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [images.length]);
 
  const prev = () => setCurrent((prev) => (prev - 1 + images.length) % images.length);
  const next = () => setCurrent((prev) => (prev + 1) % images.length);
 
  return (
    <div style={{ position: "relative", width: "100%", height: "384px", overflow: "hidden", borderRadius: "2px" }}>
      
      {images.map((image, index) => (
        <div
          key={index}
          style={{
            position: "absolute",
            inset: 0,
            opacity: index === current ? 1 : 0,
            transition: "opacity 0.7s ease",
          }}
        >
          <img
            src={image.url}
            alt={image.alt || `${title} ${index + 1}`}
            loading="lazy"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
      ))}
 
      {/* Botão Anterior */}
      <button
        onClick={prev}
        style={{
          position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.5)", color: "white", border: "none", borderRadius: "50%",
          width: "36px", height: "36px", fontSize: "18px", cursor: "pointer", zIndex: 10,
        }}
      >
        ‹
      </button>
 
      {/* Botão Próximo */}
      <button
        onClick={next}
        style={{
          position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.5)", color: "white", border: "none", borderRadius: "50%",
          width: "36px", height: "36px", fontSize: "18px", cursor: "pointer", zIndex: 10,
        }}
      >
        ›
      </button>
 
      {/* Bolinhas indicadoras */}
      <div style={{ position: "absolute", bottom: "12px", left: "50%", transform: "translateX(-50%)", display: "flex", gap: "6px", zIndex: 10 }}>
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            style={{
              width: "8px", height: "8px", borderRadius: "50%", border: "none", cursor: "pointer",
              background: index === current ? "white" : "rgba(255,255,255,0.4)",
              padding: 0,
            }}
          />
        ))}
      </div>
 
    </div>
  );
};
